// Product Fan Carousel
document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.collection-product-card');

    carousels.forEach(carousel => {
        const slides = Array.from(carousel.querySelectorAll('.media img'));
        const prevButton = carousel.querySelector('.prev');
        const nextButton = carousel.querySelector('.next');
        let currentSlide = 0;
        const positionIncrement = 10; // Adjust this value for more/less spacing
        let isHovered = false;

        function setSlidesPosition() {
            slides.forEach((slide, index) => {
                const adjustedIndex = (index + slides.length - currentSlide) % slides.length;
                const topPos = -positionIncrement * adjustedIndex;
                const rightPos = -positionIncrement * adjustedIndex;
                slide.style.transform = `translate(${-rightPos}px, ${topPos}px)`;
                slide.style.zIndex = slides.length - adjustedIndex; // Set z-index in descending order for other slides
            });
        }

        function resetOtherSlidesPosition() {
            slides.forEach((slide, index) => {
                if (index !== currentSlide) {
                    slide.style.transform = 'translate(0, 0)';
                }
            });
        }

        function toggleSlidesPosition() {
            if (isHovered) {
                setSlidesPosition();
            } else {
                resetOtherSlidesPosition();
            }
        }

        carousel.addEventListener('mouseenter', function() {
            isHovered = true;
            toggleSlidesPosition();
        });

        carousel.addEventListener('mouseleave', function() {
            isHovered = false;
            toggleSlidesPosition();
        });

        if (prevButton) {
            prevButton.addEventListener('click', function() {
                currentSlide = (currentSlide - 1 + slides.length) % slides.length;
                toggleSlidesPosition();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function() {
                currentSlide = (currentSlide + 1) % slides.length;
                toggleSlidesPosition();
            });
        }

    });
});